import { getVendorRecurrency } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useGetVendorRecurrency() {
  //Fetching Vendor Details
  return useQuery("GetVendorRecurrency", getVendorRecurrency, {
    refetchOnWindowFocus: false,
  });
}
